/* Componente per il calcolo del percorso */

import React, { Component } from 'react'
import { memo } from "react";
//import { useEffect } from "react";
import '../Calcolo_percorso/CalcoloPercorso.css'
import SearchBar from './SearchBar/SearchBar'
import SearchBar2 from './SearchBar/SearchBar2'
import GroupButton from './Filtri/GroupButton'
import DataOra from './DataOra/DataOra'
import PartenzaArrivo from './PartenzaArrivo/PartenzaArrivo'
//import CheckBox from './CheckOption/checkOption'
import CheckAccessibilita from './CheckAccesibilita/CheckAccessibilita'
import CheckRealTime from './CheckRealTime/CheckRealTime'
import InvertiButton from './InvertiButton/InvertiButton'
import ListPercorso from './List/ListaPercorso'
import Alert from '@material-ui/lab/Alert';
import { connect } from 'react-redux'
import {changeBanner, changeMarkerError} from '../redux';
import {changeLayerDrawer,changePercorsoDrawer,selectNewMarkerStart2,selectNewMarkerEnd2,fetchPathSuccess,changepositionEnd,selectNewCercaFermata,fetchPath,selectNewIndex, selectNewMarkerStart, selectNewMarkerEnd,changeNomeFermataStart,changeNomeFermataEnd,changeRegioneAereoArrivo,changeRegioneAereoPartenza,changePolyReal,changePositionTariffaStart,changePositionTariffaEnd,selectNewPosition,changepositionStart,changePercorsoTariffa} from '../redux'
import { Trans } from 'react-i18next';
import i18n from 'i18next';
import Ordinamento from './Ordinamento/Ordinamento'
import axios from 'axios';
//import { now } from 'moment'
//import { TimePickerView } from '@material-ui/pickers'
import SearchBarTrovafermate from './SearchBar/SearchBarTrovafermate'

class CalcoloPercorso extends Component {
      constructor() {
          super();
          this.state = {
              partenza: null,
              arrivo: null,
              mezzo: "TRANSIT%2CWALK",
              date: new Date(),
              //option: false,
              partenzaArrivo: false,
              buttonPosition: -10, //0
              accessibilita: false,
              realTime: true,
              json: "",
              numberOfItem: -1,
              key: 0,
              ordinamento:0,
              ricalcolo: 1,
              dataFermate: [],
              alertflag:false,
              positionNordSud : [],
              positionEstOvest : [],
              maxWalkDistance : 1000,
              cercaFermata: null
          }
      }
       readCookie(name) {
        var c = document.cookie.split('; '),
        cookies = {}, i, C;
        for (i = c.length - 1; i >= 0; i--) {
            C = c[i].split('=');
            cookies[C[0]] = C[1];
         }
         return cookies[name];
      }
      
      getZoomPartenza(partenza){
        this.props.markerStart(partenza)
        if(window.innerWidth<768 && partenza) this.props.closeButton()
      }
      getZoomArrivo(arrivo){
        this.props.markerEnd(arrivo)
        if(window.innerWidth<768 && arrivo) this.props.closeButton()
      }
      getZoomFermata(cercaFermata){
        this.props.changeCercaFermata(cercaFermata)
        if(window.innerWidth<768 && cercaFermata) this.props.closeButton()
      }
      //funzione per attivare il calcolo del percorso premendo sul risultato della search bar
      getResponsePartenza(partenza){  
        if(partenza && partenza.lat && partenza.lat!== ""){
          this.props.markerStart2(partenza)
          this.setState({partenza: partenza});
          this.props.changepositionStart(partenza)
          //this.props.changePositionTariffaStart({description:`${partenza.description}`,lat:`${partenza.lat}`,lng:`${partenza.lng}`})
          this.props.changeNomeFermataStart(partenza.description)
            try {              
              if(!this.props.percorsoTariffa.percorsoTariffa) this.callCalcolaPercorsoArrivoPartenza(partenza,this.state.arrivo)  
              //this.callCalcolaPercorso()    
            } catch (error) {}   
        } else {
          this.props.markerStart2([])
          this.setState({partenza: null});
          //this.props.changePositionTariffaStart(null)
          this.props.changeNomeFermataStart(null)
          this.ResetPath()
        }
      }

      
      //funzione per attivare il calcolo del percorso premendo sul risultato della search bar
      getResponseArrivo(arrivo){
        if(arrivo && arrivo.lat && arrivo.lat!== ""){
          this.props.markerEnd2(arrivo)
          this.setState({arrivo: arrivo});
          this.props.changepositionEnd(arrivo)
          //this.props.changePositionTariffaEnd({description:`${arrivo.description}`,lat:`${arrivo.lat}`,lng:`${arrivo.lng}`})
          this.props.changeNomeFermataEnd(arrivo.description)

          try {
              if(!this.props.percorsoTariffa.percorsoTariffa) this.callCalcolaPercorsoArrivoPartenza(this.state.partenza,arrivo)  
              //this.callCalcolaPercorso()
            } catch (error) {
          }
        } else {
          this.props.markerEnd2([])
          this.setState({arrivo: null});
          //this.props.changePositionTariffaEnd(null)
          this.props.changeNomeFermataEnd(null)
          this.ResetPath()
        }
      }
      
    getResponseCercaFermata(cercaFermata){   
      this.setState({cercaFermata})  
      this.getZoomFermata(cercaFermata)
    }


      //funzione per attivare il calcolo del percorso in base al mezzo scelto
      getMezzo(mezzo) {
        this.setState({mezzo: mezzo})  
        try {            
            //this.callCalcolaPercorso()
           this.ResetPath()
          } catch (error) {
        }
      }

      getDate(date){
        this.setState({date: date})
        this.ResetPath()
      }

      //funzione che calcola il percorso in base all'ordinamento
      setOrdinamento(ordinamento){        
        this.setState({ordinamento: ordinamento})
        try {            
          this.callCalcolaPercorso(false) 
          } catch (error) {
        }           
      }

/*
    setOption(option){      
      this.props.callback(option)
      option ? this.setState({buttonPosition: -10}) : this.setState({buttonPosition: 0})
      this.setState({option})
    }*/

    setAccessibilita(accessibilita){
      this.setState({accessibilita})
      this.ResetPath()
    }

    setRealTime(realTime){
      this.setState({realTime})
    }
  
    getPartenzaArrivo(partenzaArrivo){
      this.setState({partenzaArrivo})
      this.ResetPath()
    }
    
    
    //funzione che restituisce il tipo di mezzo, anche extra-sardegna
    getTipoMezzoOut(nome) {
      switch(nome) {
        case 'walk':
          return 'WALK';
        case 'airplane':
          return 'AIRPLANE%2CCAR';
        case 'ferry':
          return 'FERRY%2CCAR';
        case 'bike':
          return 'BICYCLE';
        case 'common':
          return 'TRANSIT%2CWALK';
        default:
          return 'TRANSIT%2CWALK';
      }
    }

    //funzione che restituisce il tipo di mezzo, per trasferimenti dentro la sardegna
    getTipoMezzoIn(nome) {
      switch(nome) {
        case 'walk':
          return 'WALK';
        case 'airplane':
          return 'AIRPLANE%2CCAR';
        case 'ferry':
          return 'FERRY%2CCAR';
        case 'bike':
          return 'BICYCLE';
         case 'common':
          return 'BUS%2CRAIL%2CTRAM%2CFERRY%2CWALK'; 
        default:
          return 'BUS%2CRAIL%2CTRAM%2CFERRY%2CWALK';
      }
    }
    

    callCalcolaPercorso(saveStatistiche=true){      
      this.callCalcolaPercorsoArrivoPartenza(this.state.partenza,this.state.arrivo,saveStatistiche)   
    }
    callCalcolaPercorsoArrivoPartenza(partenzaInput,arrivoInput,saveStatistiche=true){
      let start = partenzaInput
      try{
        if(arrivoInput && !start && this.props.positions.position) {
          start = this.props.positions.position
          let description = `${start.lat.toFixed(8)},${start.lng.toFixed(8)}`
          let point = { description: description, lat: `${start.lat.toFixed(8)}`, lng: `${start.lng.toFixed(8)}` }
          this.props.changeNomeFermataStart(description)
          this.props.changepositionStart(point)
          //this.props.changePositionTariffaStart([{ description: `${start.lat},${start.lng}`, lat: `${start.lat.toFixed(8)}`, lng: `${start.lng.toFixed(8)}` }])
          this.props.markerStart2(start)
        }
        if(start && arrivoInput){
          var mode = this.getTipoMezzoOut(this.state.mezzo)
          if( window.configFile.serviceOnScreen.prepost_elaboration && this.isInSardegna(start.lat,start.lng) === this.isInSardegna(arrivoInput.lat,arrivoInput.lng)) mode = this.getTipoMezzoIn(this.state.mezzo)

          const partenza = `${start.lat}%2C${start.lng}`        
          const arrivo = `${arrivoInput.lat}%2C${arrivoInput.lng}`        
          const time = `${this.state.date.getHours()}%3A${this.state.date.getMinutes()}`        
          const timeChiamata = `${this.state.date.getHours()}:${this.state.date.getMinutes()}`        
          const date = `${this.state.date.getMonth()+1}-${this.state.date.getDate()}-${this.state.date.getFullYear()}`       
          const dateChiamata = `${this.state.date.getFullYear()}-${this.state.date.getMonth()+1}-${this.state.date.getDate()}`
          const arriveBy = `${this.state.partenzaArrivo}`        
          const wheelchair = `${this.state.accessibilita}`      
          let operator = (window.tp_operator)? window.tp_operator : ""
          //let url = this.state.option ? `${this.props.httpProxy.urlOTP}/plan?fromPlace=${partenza}&toPlace=${arrivo}&mode=${mode}&time=${time}&date=${date}&arriveBy=${arriveBy}&maxWalkDistance=${this.props.parameters.maxWalkDistance}&wheelchair=${wheelchair}&locale=it&whiteListedAgencies=${operator}` : url=`${this.props.httpProxy.urlOTP}/plan?fromPlace=${partenza}&toPlace=${arrivo}&mode=${mode}&maxWalkDistance=${this.props.parameters.maxWalkDistance}&wheelchair=${wheelchair}&locale=it&whiteListedAgencies=${operator}`        
          let url = `${this.props.httpProxy.urlOTP}/plan?fromPlace=${partenza}&toPlace=${arrivo}&mode=${mode}&time=${time}&date=${date}&arriveBy=${arriveBy}&maxWalkDistance=${this.props.parameters.maxWalkDistance}&wheelchair=${wheelchair}&locale=it&whiteListedAgencies=${operator}`        
          this.callFetch(url,this.state.ordinamento)   
          this.props.changePolyReal(false)       
          if(saveStatistiche) this.statisticheVisore(start,mode,dateChiamata,timeChiamata)
        }
      } catch(error){}
    }

    isInSardegna(lat,lng){
      /*const minLat = 38.741138
      const maxLat = 41.354026
      const minLng = 7.918701
      const maxLng = 9.907226*/
      const minLat = this.props.parameters.sardegnaBox.minLat
      const maxLat = this.props.parameters.sardegnaBox.maxLat
      const minLng = this.props.parameters.sardegnaBox.minLng
      const maxLng = this.props.parameters.sardegnaBox.maxLng
      if(lat < maxLat && lat > minLat && lng < maxLng && lng > minLng) return true
      else return false;
    }

    statisticheVisore(start,mode,dateChiamata,timeChiamata) {
      /* if (this.props.banner.banner === true  */ 
      if((!this.readCookie('cookie-agreed') || this.readCookie('cookie-agreed') === "2") && this.props.httpProxy.urlStat && this.props.httpProxy.urlStat !== ''){   
        const urlStatistiche = `${this.props.httpProxy.urlStat}`
        const wheelchair = `${this.state.accessibilita}`
        
        axios.post(urlStatistiche,{
          headers: window.tp_headers,
          departure_lat:start.lat,
          departure_lon:start.lng,
          arrival_lat:this.state.arrivo.lat,
          arrival_lon:this.state.arrivo.lng,
          departure_name_address:start.description,
          arrival_name_address:this.state.arrivo.description,
          transportation_choice:mode,
          weelchair_boarding:wheelchair,
          departure_comune:start.town,
          arrival_comune:this.state.arrivo.town,
          departure_provincia:start.county,
          arrival_provincia:this.state.arrivo.county,
          departure_regione:start.state,
          arrival_regione:this.state.arrivo.state,
          trip_date:dateChiamata +" "+ timeChiamata,
          trip_date_type:"1",
          privacy_accepted:true,
          user_type:1,
          departure_stop_type:start.type,
          arrival_stop_type:this.state.arrivo.type
        }).then(response => {}) 
      }

    }

    callFetch(url,ordinamento){
      
      this.setState(function(prevState) {
        const  key = this.state.key + 1
        return {key: key};
      });
      this.props.selectIndex(0)
      //this.props.markerStart("")
      //this.props.markerEnd("")  
      const url2 = {url:url,ordine:ordinamento}  
      this.props.fetchPath(url2)
    }
    //funzione che calcola il percorso premendo sul button Calcola
    startPath() {
      //const mode2 = this.getTipoMezzo2(this.state.mezzo) 
      this.callCalcolaPercorso()      
    }
      //restituisce la lista dei percorsi
      percorso = (data) => {
        
        try {
          
        if(document.getElementsByClassName("listaPercorso") && document.getElementsByClassName("listaPercorso").length===1) document.getElementsByClassName("listaPercorso")[0].style.display = "flex"
          return (<div>
            <div className={"ordineTesto"}>
              <Trans>Ordina</Trans>
            </div>
            <div className={"ordinamento"}>
             <Ordinamento callback={this.setOrdinamento.bind(this)} /> 
            </div>
          <ListPercorso realTime={this.state.realTime} key={this.state.key} index={(data.paths.plan.itineraries).length} data={data.paths} stato ={[true,false,false,false,false,false,false,false,false,false]} />
          </div>)
        } catch(error) {         
              try {            
                if (data.error || ((data.paths.error.id) === 400 || (data.paths.error.id) === 404 || (data.paths.error.id) === 406)) {
                   
                   //this.props.changeMarkerError(true)
                    return (<div className={"alert"}>
                      <Alert  variant="outlined" severity="warning">
                                <p><Trans>Nessun percorso trovato.</Trans></p>
                                <p>{i18n.t("Verifica_percorso_1")}</p>
                                <p>{i18n.t("Verifica_percorso_2")}</p>
                                <p>{i18n.t("Verifica_percorso_3")} <a href={"mailto:" + window.configFile.httpProxy.mailTo}>{window.configFile.httpProxy.mailTo}</a></p>
                              </Alert>
                              
                              {/* { this.props.changeMarkerError(true)} */}
                              {/* <Alert  variant="outlined" severity="warning">
                                <Trans>Nessun percorso trovato</Trans>
                              </Alert> */}
                            </div>)
                            
                }
              }catch(error){
                
          }
        }

        
      }
    
   componentDidUpdate(propsPrecedenti){
      if (propsPrecedenti.pathData !== this.props.pathData){
        try {
          if ((this.props.pathData.paths.error.id) === 400 || (this.props.pathData.paths.error.id) === 404) {
            this.setState({alertflag: true})
              }else {                
                this.setState({ricalcolo: 1})
              }
            }catch(error){}
          }  
          if (propsPrecedenti.positionStart !== this.props.positionStart){
          
            try {
              const split = this.props.positionStart.positionStart.split(',')
              
              if (split.length >0) {
                
              this.setState({partenza: {lat:split[0],lng:split[1]}})
              }
            } catch (error) {
              
            }
          }
          if (propsPrecedenti.positionEnd !== this.props.positionEnd){
            try {
              const split = this.props.positionEnd.positionEnd.split(',')
              if (split.length >0) {
              this.setState({arrivo: {lat:split[0],lng:split[1]}})
              }
            } catch (error) {
              
            }

          }
      // this.startPath()
    }

      invertSearch(){
        try {
          const tempPartenza = this.state.partenza   
          const tempArrivo = this.state.arrivo   

          this.setState({partenza: tempArrivo})   
          this.setState({arrivo: tempPartenza})   
          this.props.markerStart(tempArrivo)
          this.props.markerEnd(tempPartenza)    

          this.props.changePositionTariffaStart([{description:`${this.props.nomeFermataEnd.nomeFermataEnd}`,lat:`${tempArrivo.lat}`,lng:`${tempArrivo.lng}`}])
          this.props.changeNomeFermataStart(this.props.nomeFermataEnd.nomeFermataEnd)
          this.props.changePositionTariffaEnd([{description:`${this.props.nomeFermataStart.nomeFermataStart}`,lat:`${tempPartenza.lat}`,lng:`${tempPartenza.lng}`}])
          this.props.changeNomeFermataEnd(this.props.nomeFermataStart.nomeFermataStart)    
        
          this.callCalcolaPercorsoArrivoPartenza(tempArrivo,tempPartenza,true)     

        } catch (error) {
         
        }
  
      }

      ResetPath =()=> {
        this.props.fetchPathSuccess({})
        //this.setState({pathData: {}});
        document.getElementsByClassName("listaPercorso")[0].style.display = "none"
      }
  
      Reset =()=> {
      
      this.props.markerStart([])
      this.props.markerEnd([])
      this.setState({partenza: null});
      this.setState({arrivo: null});
      this.setState({cercaFermata: null});
      //this.props.changePositionTariffaStart(null)
      this.props.changeNomeFermataStart("")
      //this.props.changePositionTariffaEnd(null)
      this.props.changeNomeFermataEnd("")
      this.props.changepositionStart(null)
      this.props.changepositionEnd(null)
      this.props.changePolyReal(false)  
      this.props.changeCercaFermata(null)
      this.ResetPath()
      document.getElementById("zoom_sardegna").click()
      this.props.changeLayerDrawer(false)
      
/*
      var a = (new URL(document.location))
      window.location.replace(a.href);
      
      /*a.searchParams.set("fromPlace","")
      a.searchParams.set("toPlace","")
      a.searchParams.set("address_from","")
      a.searchParams.set("address_to","")
      a.searchParams.toString()*/
      
      //this.props.pathData === false
    }

    componentDidMount() {
      //PRIMO PERCORSO VISUALIZZATO SE PRESENTI PARAMETRI DI RICERCA IN GET
      try {
        //Importazione package qs
        var qs = require('qs');
        let search = this.props.search        
        var fromPlace = qs.parse(search, { ignoreQueryPrefix: true }).fromPlace
        var toPlace = qs.parse(search, { ignoreQueryPrefix: true }).toPlace
        var addressFrom = qs.parse(search, { ignoreQueryPrefix: true }).address_from
        var addressTo = qs.parse(search, { ignoreQueryPrefix: true }).address_to

        var pointFrom = null
        var pointTo = null
        if (fromPlace && fromPlace !== "" && (!addressFrom || addressFrom === "")) addressFrom = `${fromPlace}`
        if (toPlace && toPlace !== "" && (!addressTo || addressTo === "")) addressTo = `${toPlace}`
        if (fromPlace && fromPlace !== "" && addressFrom && addressFrom !== "" ) pointFrom = { description: `${addressFrom}`, lat: `${fromPlace.split(",")[0]}`, lng: `${fromPlace.split(",")[1]}` }
        if (toPlace && toPlace !== "" && addressTo && addressTo !== "") pointTo = { description: `${addressTo}`, lat: `${toPlace.split(",")[0]}`, lng: `${toPlace.split(",")[1]}` }
      
        if (pointFrom){
          this.props.changepositionStart(pointFrom)
          this.props.changeNomeFermataStart(pointFrom.description)
          this.setState({partenza: pointFrom});
          //this.props.changePositionTariffaStart(pointFrom)
          this.props.markerStart2(pointFrom)
        } 
        if (pointTo) {
          this.props.changepositionEnd(pointTo)
          this.props.changeNomeFermataEnd(pointTo.description)
          this.setState({arrivo: pointTo});
          //this.props.changePositionTariffaEnd(pointTo) 
          this.props.markerEnd2(pointTo)
        }

        if (pointTo){
          this.callCalcolaPercorsoArrivoPartenza(pointFrom,pointTo)
        }
      } catch (error) {
        console.log(error.error)
      }   
    
    }
    
       
      render() {
        
          return (
              <div >
                
                  <div className={'main'} >
                    <div className={"cercaFermataDiv"}>
                        <SearchBarTrovafermate titolo="Cerca fermata" placeholder={i18n.t("Scrivi il punto fermata")} stato={this.state.cercaFermata} callback={this.getResponseCercaFermata.bind(this)} callback2={this.getZoomFermata.bind(this)} dataFermate={this.state.dataFermate}/>
                    </div> 
                      <div className={"searchBarDiv"}>
                        <SearchBar titolo="Parti da" placeholder="Scrivi il punto di partenza" callback={this.getResponsePartenza.bind(this)} callback2={this.getZoomPartenza.bind(this)} stato={this.state.partenza} dataFermate={this.state.dataFermate}/>
                        <SearchBar2 titolo="Arriva a" placeholder="Scrivi il punto di destinazione" callback={this.getResponseArrivo.bind(this)} callback2={this.getZoomArrivo.bind(this)} stato={this.state.arrivo} dataFermate={this.state.dataFermate}/> 
                        <InvertiButton callback={this.invertSearch.bind(this)}></InvertiButton>
                      </div>
                      <GroupButton callback={this.getMezzo.bind(this)}/>
                  {/* <CheckBox callback={this.setOption.bind(this)}/> */}
                      {/* <div className={"parData"}  style={this.state.option ? {display: 'flex'}: {display: 'none'}}>*/}
                      <div className={"parData"} style={{display: 'flex'}}>                 
                        <div className={"div1"}><PartenzaArrivo callback={this.getPartenzaArrivo.bind(this)} partenza={this.state.partenzaArrivo}/></div> 
                        <div className={"div2"}><DataOra callback={this.getDate.bind(this)} dataOra={this.state.date}/></div> 
                      </div>
                      {/* this.state.option ? */
                        <div className={"opzioniVarie"}>
                          <div/>
                          <CheckAccessibilita callback={this.setAccessibilita.bind(this)} accessibilita={this.state.accessibilita}/>
                          <CheckRealTime callback={this.setRealTime.bind(this)} realTime={this.state.realTime}/>
                        </div>
                      /*: null */}
                  </div>

                  <div className={"calcolaButton"} style={{bottom: this.state.buttonPosition}}>
                      <button className={"buttonStyle"} id={"calcolaButton"} onClick={this.startPath.bind(this)}><Trans>Calcola</Trans></button>
                      <button className={"resetStyle"} onClick={this.Reset}>Reset</button> 
                  </div>
                  <div className="listaPercorso" id='percorsiTrovati'>
                      {this.percorso(this.props.pathData)}                       
                  </div>
              </div>
          )
      }
}

const mapStateToProps = state => {
  return {
      pathData: state.path,
      indexData: state.index,
      positionStart: state.positionStart,
      positionEnd: state.positionEnd,
      markerStart: state.markerStart,
      markerEnd: state.markerEnd,
      markerStart2: state.markerStart2,
      markerEnd2: state.markerEnd2,
      position:state.position,
      nomeFermataStart: state.nomeFermataStart,
      nomeFermataEnd:state.nomeFermataEnd,
      banner : state.banner,
      regioneAereoPartenza: state.regioneAereoPartenza,
      regioneAereoArrivo : state.regioneAereoArrivo,
      polyReal : state.polyReal,
      positionTariffaStart : state.positionTariffaStart,
      positionTariffaEnd : state.positionTariffaEnd,
      markerError : state.markerError,
      cercaFermata: state.cercaFermata,
      percorsoDrawer : state.percorsoDrawer,
      percorsoTariffa :state.percorsoTariffa,
      layerDrawer : state.layerDrawer,
      positions: state.position
  }
}

const mapDispatchToProps = dispatch => {
  return {
      fetchPath: (url,nome) => dispatch(fetchPath(url,nome)),
      selectIndex: (index) => dispatch(selectNewIndex(index)),
      markerStart: (marker) => dispatch(selectNewMarkerStart(marker)),
      markerEnd: (marker) => dispatch(selectNewMarkerEnd(marker)),
      markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
      markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
      changeNomeFermataStart: (nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
      changeNomeFermataEnd: (nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
      changeBanner: (banner) => dispatch(changeBanner(banner)),
      changeRegioneAereoPartenza : (regioneAereoPartenza) => dispatch(changeRegioneAereoPartenza(regioneAereoPartenza)),
      changeRegioneAereoArrivo : (regioneAereoArrivo) => dispatch(changeRegioneAereoArrivo(regioneAereoArrivo)),
      changePolyReal : (polyReal) => dispatch(changePolyReal(polyReal)),
      changePositionTariffaStart:(positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
      changePositionTariffaEnd:(positionTariffaEnd) => dispatch(changePositionTariffaEnd(positionTariffaEnd)),
      changeMarkerError : (markerError) => dispatch(changeMarkerError(markerError)),
      changeCercaFermata : (marker) => dispatch(selectNewCercaFermata(marker)),
      position: (position) => dispatch(selectNewPosition(position)),
      changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
      changepositionEnd: (positionStart) => dispatch(changepositionEnd(positionStart)),
      changePercorsoTariffa : (percorsoTariffa) => dispatch(changePercorsoTariffa(percorsoTariffa)),   
      changePercorsoDrawer: (percorsoDrawer) => dispatch(changePercorsoDrawer(percorsoDrawer)),
      changeLayerDrawer : (layerDrawer) => dispatch(changeLayerDrawer(layerDrawer)),
      fetchPathSuccess : (path) => dispatch(fetchPathSuccess(path)) 
  }
}


export default memo(connect(mapStateToProps,mapDispatchToProps)(CalcoloPercorso))
